import {ISSUE_ROOT_CAUSES_PERMITTED_ACTIONS} from '../constants/issue-root-causes';
import lodashGet from 'lodash/get';
import i18n from './i18n';
import {maxLengthValidator, uniqueValueValidator} from './validation-helpers';

export const isStandardRootCauseCategory = rootCauseCategory => {
  const permittedActions = lodashGet(rootCauseCategory, 'permittedActions');
  return permittedActions && !permittedActions.includes(ISSUE_ROOT_CAUSES_PERMITTED_ACTIONS.CAN_DELETE);
};

export const issueRootCauseCategoryInputValidators = (issueRootCauseNames, existsTranslationKey = 'categoryExists') => [
  {
    message: i18n.t('issueRootCauses.modal.maxCharactersLimit'),
    validate: maxLengthValidator(100)
  },
  {
    message: i18n.t(`issueRootCauses.modal.${existsTranslationKey}`),
    validate: uniqueValueValidator(issueRootCauseNames)
  }
];

export const issueRootCauseInputValidators = issueRootCauseNames =>
  issueRootCauseCategoryInputValidators(issueRootCauseNames, 'rootCauseExists');
